import { createFileRoute } from "@tanstack/react-router";
import { Navbar, Footer } from "@/components/hilltop";
import { Performance } from "@/components/hilltop/Performance";

export const Route = createFileRoute("/_public/performance")({
  component: PerformancePage,
});

function PerformancePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Performance />
      <Footer />
    </div>
  );
}
